import React from 'react';
import { ActionButton, type ActionButtonData } from '../action-button/ActionButton';
import { t } from '../../services/locale';

export type ProfileLinkedAccount = {
  _id?: string;
  name?: string;
};

export type ProfileLinkedAccountsData = {
  isGuardAccount?: boolean;
  isChildAccount?: boolean;
  linkedAccounts?: ProfileLinkedAccount[];
  addLinkedAccountActionData?: ActionButtonData;
  switchToParentAccountActionData?: ActionButtonData;
  getUseAccountActionData?: (account: ProfileLinkedAccount) => ActionButtonData;
  onUseAccount?: (account: ProfileLinkedAccount) => void;
  onAddLinkedAccount?: () => void;
  onSwitchToParent?: () => void;
};

type Props = Readonly<{
  data?: ProfileLinkedAccountsData;
}>;

function GuardAccounts({ data }: Readonly<{ data: ProfileLinkedAccountsData }>) {
  const linkedAccounts = data.linkedAccounts ?? [];
  const isEmpty = linkedAccounts.length === 0;

  return (
    <div>
      {isEmpty ? (
        <div className="list-label">{t('WEB_NO_ACCOUNTS_ASSOCIATED_MESSAGE')}</div>
      ) : (
        <ul className="list">
          {linkedAccounts.map((linkedAccount, index) => {
            const useAccountData = data.getUseAccountActionData?.(linkedAccount);
            return (
              <li key={linkedAccount._id ?? index}>
                <div className="list-text-left">
                  <h5>{linkedAccount.name}</h5>
                </div>
                <div className="list-text-right">
                  {useAccountData ? (
                    <span className="profile-action-button">
                      <ActionButton
                        data={{
                          ...useAccountData,
                          onClick: () => data.onUseAccount?.(linkedAccount),
                        }}
                      />
                    </span>
                  ) : null}
                </div>
              </li>
            );
          })}
        </ul>
      )}
      {data.addLinkedAccountActionData ? (
        <span className="profile-action-button create-linked-account-btn-host">
          <ActionButton
            data={{
              ...data.addLinkedAccountActionData,
              onClick: () => data.onAddLinkedAccount?.(),
            }}
          />
        </span>
      ) : null}
    </div>
  );
}

function ChildAccount({ data }: Readonly<{ data: ProfileLinkedAccountsData }>) {
  return (
    <div>
      <div className="list-label">{t('WEB_PARENT_ACCOUNT_MESSAGE')}</div>
      {data.switchToParentAccountActionData ? (
        <span className="profile-action-button create-linked-account-btn-host">
          <ActionButton
            data={{
              ...data.switchToParentAccountActionData,
              onClick: () => data.onSwitchToParent?.(),
            }}
          />
        </span>
      ) : null}
    </div>
  );
}

export function ProfileLinkedAccounts({ data }: Props) {
  if (!data) {
    return null;
  }
  if (data.isGuardAccount) {
    return <GuardAccounts data={data} />;
  }
  if (data.isChildAccount) {
    return <ChildAccount data={data} />;
  }
  return null;
}
